<template>
  <v-app-bar
    id="app-bar"
    absolute
    app
    color="transparent"
    flat
    height="45"
  >
    <!-- <v-btn
      class="mr-3"
      elevation="1"
      fab
      small
      @click="$vuetify.breakpoint.smAndDown ? setDrawer(!drawer) : $emit('input', !value)"
    >
      <v-icon v-if="value">
        mdi-view-quilt
      </v-icon>

      <v-icon v-else>
        mdi-dots-vertical
      </v-icon>
    </v-btn> -->

    <common-breadcrumb class="font-weight-light mobile-hidden" :breadcrumb="_.get($route, 'meta.breadcrumb', [])" />

    <v-spacer />

    <div class="mx-3" />

    <div class="announcement-container mobile-hidden d-flex" v-if="announcements.length" :style="'width:' + marqueeWidth">
      <div style="width: 22px">
        <v-icon size="20px" style="padding-bottom: 2px; color: red">mdi-bullhorn</v-icon>
      </div>
      <div class="announcement" @mouseenter="startScroll()" @mouseleave="stopScroll()">
        <span v-for="(item, index) in announcements" :key="index" class="announcement-pack">
          <span v-html="item.content" :class="item.link ? 'mr-5 announcement-text has-link' : 'mr-5 announcement-text'" @click="openLinkAnnouncement(item.link)">
<!--          {{ item.content }}-->
          </span>
          <span class="mr-5" v-if="(index + 1) < announcements.length"> | </span>
        </span>
      </div>
    </div>

    <v-spacer />

    <common-select-type-school-level-dashboard/>

    <v-menu
      bottom
      left
      offset-y
      origin="top right"
      transition="scale-transition"
      min-width="300"
      max-width="400"
    >
      <!-- <template v-slot:activator="{ attrs, on }">
        <v-btn
          class="ml-2 mobile-hidden"
          min-width="0"
          text
          v-bind="attrs"
          v-on="on"
        >
          <v-badge
            color="red"
            overlap
            bordered
          >
            <template v-if="appointments.length" v-slot:badge>
              <span>{{ totalItem }}</span>
            </template>
            <template v-else v-slot:badge>
              <span>0</span>
            </template>
            <v-icon class="appbar-icon"> mdi-timer</v-icon>
          </v-badge>
        </v-btn>
      </template> -->

      <v-list
        :tile="false"
        nav
      >
        <div>
          <div class="notification-header">
            <h4>Danh sách lịch hẹn</h4>
          </div>
          <div class="notification-height">
            <app-bar-item
              v-for="(appointment, i) in appointments"
              :key="`item-${i}`"
              class="pa-0 ma-0"
            >
              <v-list-item-title>
                <div class="notification pa-0 ma-0">
                  <div class="notification-action" @click="editAppointment(appointment)"></div>
                  <div class="notification-info">
                    <div class="notification-item" style="padding-top: 5px">
                      <span class="font-weight-bold">{{ checkIsTodayOrTomorrow(_.get(appointment, 'date')) }} - {{ _.get(appointment.customer, 'fullName') }}</span>
                    </div>
                    <div class="notification-item" style="float: right">
                      <span class="font-weight-bold">{{ _.get(appointment, 'mobile') }}</span>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn class="icon-call" icon small color="default" v-on="on"><v-icon>mdi-bell</v-icon></v-btn>
                        </template>
                        <span>Chi tiết lịch hẹn</span>
                      </v-tooltip>
                    </div>
                  </div>
                  <div class="notification-item notification-item--des mt-2" style="padding: 0px 10px 5px">
                    <div style="white-space: normal; overflow-wrap: break-word">Ghi chú: {{ _.get(appointment, 'description') }}</div>
                  </div>
                </div>
              </v-list-item-title>
            </app-bar-item>
            <div class="text-center" v-show="(appointments.length < 1 ? true : false)">
              <label>Không có lịch hẹn nào</label>
            </div>
          </div>
          <template v-if="totalItem > 5">
            <router-link :to="{name: 'Appointment'}">
              <v-btn
                color="primary"
                text
              >
                Xem thêm
              </v-btn>
            </router-link>
          </template>
        </div>
      </v-list>
    </v-menu>


    <v-menu
      bottom
      left
      min-width="200"
      offset-y
      origin="top right"
      transition="scale-transition"
    >
      <template v-slot:activator="{ attrs, on }">
        <v-btn
          class="ml-2"
          min-width="0"
          text
          v-bind="attrs"
          v-on="on"
        >
          <v-icon class="appbar-icon">mdi-account</v-icon>
        </v-btn>
      </template>

      <v-list
        :tile="false"
        flat
        nav
      >
<!--        <app-bar-item-->
<!--          to="/profile"-->
<!--        >-->
<!--          <v-list-item-title v-text="'My profile'" />-->
<!--        </app-bar-item>-->
<!--        <app-bar-item-->
<!--          :class="checkAuthorization('order-ctv-create_read') && !checkAuthorization('contact_read') ? 'hiden-person-result' : ''"-->
<!--          to="/profile/report"-->
<!--        >-->
<!--          <v-list-item-title v-text="'Thành tích của tôi'" />-->
<!--        </app-bar-item>-->
<!--        <v-divider-->
<!--          class="mb-2 mt-2"-->
<!--        />-->
        <a class="d-block btn-logout" @click="logout">
          Logout
        </a>
      </v-list>
    </v-menu>
    <video id="my-video" autoplay style="display: none;" src="https://web1.caresoft.vn/images/320x240.ogg"></video>
    <video id="peer-video" autoplay style="display: none;" src="https://web1.caresoft.vn/images/320x240.ogg"></video>

<!--    <common-voice-call/>-->
<!--    <common-voice-call-incoming/>-->
<!--    <common-voice-call-incoming-care-soft/>-->
<!--    <common-notification :hideNotifications="hideNotifications" :notificationPosition="notificationPosition" @closeNotification="closeNotification"/>-->
  </v-app-bar>
</template>

<script>
  // Components
  import { VHover, VListItem } from 'vuetify/lib'
  import handleSchedule from '@/mixins/handleSchedule'
  // Utilities
  import { mapState, mapMutations } from 'vuex'
  import TokenService from '../../helpers/token'
  import { downloadFile, downloadFileXlsx } from '../../helpers/utils';
  import RepositoryFactory from '@/repositories/RepositoryFactory'
  const PAGE_LIMIT = 10
  const AppointmentRepository = RepositoryFactory.get('appointment')

  export default {
    name: 'DashboardCoreAppBar',
    mixins: [handleSchedule],
    components: {
      AppBarItem: {
        render (h) {
          return h(VHover, {
            scopedSlots: {
              default: ({ hover }) => {
                return h(VListItem, {
                  attrs: this.$attrs,
                  class: {
                    'black--text': !hover,
                    'white--text primary elevation-12': hover,
                  },
                  props: {
                    activeClass: '',
                    dark: hover,
                    link: true,
                    ...this.$attrs,
                  },
                }, this.$slots.default)
              },
            },
          })
        },
      },
    },

    props: {
      value: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      dataAppointment: {},
      showConfirm: false,
      appointmentIds: [],
      profile: [
        { title: 'Profile' },
        { divider: true },
        { title: 'Log out' },
      ],
      totalItem: 0,
      appointments: [],
      hideNotifications: [],
      notificationPosition: [],
      remindContact: [],
      announcements: [],
      marqueeWidth: "60%",
      scrollAnnouncement: '',
      scrollLeft: 0
    }),

    computed: {
      ...mapState(['drawer']),
    },

    created () {
      //this.fetchNotifications()
      const user = TokenService.getUser()
      const self = this
      let socket = false
      if (_.isObject(user) && _.size(user)) {
        const username = _.get(user, 'username')
        socket = require('socket.io-client')(process.env.VUE_APP_NOTIFICATION_SOCKET_URL, {path: process.env.VUE_APP_NOTIFICATION_SOCKET_PATH + '/socket.io'})
        socket.on('connect', function(){
          socket.emit('user_join', { username: username })
        });
        socket.on('download_export', (res) => {
          if (res?.success) {
            this.$swal({
              icon: "success",
              title: 'Export dữ liệu thành công',
              confirmButtonText: 'Download',
            }).then(() => {
              downloadFile(_.get(res, 'csvFile', ''), _.get(res, 'fileName', ''))
            })
          } else {
            this.$swal({
              icon: "error",
              title: 'Export dữ liệu thất bại',
              text: res.message,
            })
          }
        });
        socket.on('promotion_subs_exported', (res) => {
          if (res?.success) {
            this.$swal({
              icon: "success",
              title: 'Export dữ liệu thành công',
              confirmButtonText: 'Download',
            }).then(() => {
              downloadFileXlsx(_.get(res, 'url', ''), _.get(res, 'fileName', ''))
            })
          } else {
            this.$swal({
              icon: "error",
              title: 'Export dữ liệu thất bại',
              text: res.message,
            })
          }
        });
        socket.on('promotion_sub_generated', (res) => {
          if (res?.success) {
            this.$swal({
              icon: "success",
              title: 'Thêm mã thành công',
            }).then(() => {
              Bus.$emit("promotion_sub_generated")
            })
          } else {
            this.$swal({
              icon: "error",
              title: 'Thêm mã thất bại',
              text: res.message,
            })
          }
        });
        socket.on('new_notifications', async function(data){
          const block = _.get(data, 'block', '0min')
          const newAppointment = _.get(data, 'notification', {})
          const newAppointmentId = _.get(newAppointment, 'id', 0)
          if (block === '0min') {
            self.addNewNotification(newAppointment)
          }
          else if (self.notificationPosition.indexOf(newAppointmentId) == -1 && (block == '5min')) {
            const response = await AppointmentRepository.detail(newAppointmentId, {})
            if (response.success) {
              let userPosition = TokenService.getPosition()
              let userId = TokenService.getId()
              let contact = response.data.customer.contact
              if (contact.mainId || (userPosition == 'telesales' && userId != contact.userId)) {
                return
              }
              if (!self.hideNotifications.find(data => data.id == newAppointmentId)) {
                self.notificationPosition.push(newAppointmentId)
                self.hideNotifications.push({...response.data, showModal: true})
              }
            }
          }

        });
        socket.on('import_contact_success', (csvData) => {
          console.log('import_contact_success.....');
          self.$swal({
            title: 'Đã up thành công. Để biết chi tiết kết quả khi up vui lòng download file dưới đây',
            confirmButtonText: 'Download kết quả',
            cancelButtonText: 'Huỷ',
            confirmButtonColor: '#0C8218',
            cancelButtonColor: '#848484',
            }).then(async (res) => {
              if (res.value) {
                await downloadFile(_.get(csvData, 'csvFile', ''), _.get(csvData, 'fileName', ''))
                setTimeout(() =>{
                  window.location.href = '/contact/contact-list';
                },1000)
              }
            })
        });
        socket.on('import_contact_failed', () => {
          console.log('import_contact_failed.....');
          self.$swal({
              title: 'Lỗi!',
              text: 'File upload còn contact chưa có link Url hoặc Nhóm sản phẩm để xác định nhóm ngành. Vui lòng kiểm tra lại.',
              confirmButtonText: 'Đồng ý',
          })
        });
        socket.on('remain_appointments', async (data) => {
          if (self.remindContact.indexOf(data.time) == -1
              && (parseInt(data.notification.totalAppointments) > 0 || parseInt(data.notification.totalContacts) > 0)) {
            self.$swal({
              title: 'Bạn còn ' + data.notification.totalAppointments + ' lịch hẹn chưa thực hiện<br>và ' + data.notification.totalContacts + ' contact New chưa liên lạc.',
              confirmButtonText: 'Xem danh sách lịch hẹn',
              width: '520px'
            }).then((res) => {
              self.remindContact.push(data.time)
              if (res.value) {
                self.$router.push('/users/appointment')
              }
            })
          }
        });
        socket.on('export_contact_success', (res) => {
          self.$swal({
                title: 'Export dữ liệu thành công',
                confirmButtonText: 'Download',
            }).then(() => {
              downloadFile(_.get(res, 'csvFile', ''), _.get(res, 'fileName', ''))
            })
        });
        socket.on('export_order_success', (res) => {
          self.$swal({
                title: 'Export dữ liệu thành công',
                confirmButtonText: 'Download',
            }).then(() => {
              downloadFile(_.get(res, 'csvFile', ''), _.get(res, 'fileName', ''))
            })
        });
        socket.on('export_order_success_doisoat', (res) => {
          self.$swal({
                title: 'Export dữ liệu đối soát thành công',
                confirmButtonText: 'Download',
            }).then(() => {
              downloadFile(_.get(res, 'csvFile', ''), _.get(res, 'fileName', ''))
            })
        });
        socket.on('export_order_success_accountant', (res) => {
          self.$swal({
            title: 'Export dữ liệu kế toán thành công',
            confirmButtonText: 'Download',
          }).then(() => {
            downloadFile(_.get(res, 'csvFile', ''), _.get(res, 'fileName', ''))
          })
        });
        socket.on('download_reconcicle', (res) => {
          self.$swal({
            title: 'Export dữ liệu đối soát SMS thành công',
            confirmButtonText: 'Download',
          }).then(() => {
            downloadFile(_.get(res, 'csvFile', ''), _.get(res, 'fileName', ''))
          })
        });
        socket.on('send-message-finish', (data) => {
          self.$swal({
            title: 'Đã gửi tin nhắn đi thành công.',
            confirmButtonText: 'Xem kết quả',
          }).then((res) => {
            if (res.value) {
              Bus.$emit("finish-send-sms", data)
            }
          })
        });
        socket.on('change-policy-ctv', (data) => {
          Bus.$emit("policy-ctv-updated", data)
        });
        socket.on('new_announcement', (res) => {
          let breadcrumb = document.getElementsByClassName("container-breadcrumb")
          if (breadcrumb.length) {
            self.marqueeWidth = ((window.innerWidth - breadcrumb[0].offsetWidth - 225)*0.8).toFixed(0) + 'px'
          } else {
            self.marqueeWidth = "60%"
          }
          self.announcements = res.announcement
        });
        socket.on('export_account_report_success', (res) => {
          self.$swal({
                title: 'Export dữ liệu thành công',
                confirmButtonText: 'Download',
            }).then(() => {
              downloadFile(_.get(res, 'csvFile', ''), _.get(res, 'fileName', ''))
            })
        });
        socket.on('export_account_report_class_success', (res) => {
          self.$swal({
                title: 'Export dữ liệu thành công',
                confirmButtonText: 'Download',
            }).then(() => {
              downloadFile(_.get(res, 'csvFile', ''), _.get(res, 'fileName', ''))
            })
        });
        Bus.$on('created-appointment-success', (data) => {
          socket.emit('created_appointment_success', {
            toUserName: _.get(data, 'userData.username'),
            fromUserName: username,
            notification: _.get(data, 'newAppointment'),
          })
        })
        socket.on('export_report_department_employee_success', (res) => {
          self.$swal({
            title: 'Export dữ liệu thành công',
            confirmButtonText: 'Download',
          }).then(() => {
            downloadFile(_.get(res, 'csvFile', ''), _.get(res, 'fileName', ''))
          })
        });
        socket.on('vh-update-data', (data) => {
          this.$store.dispatch('SET_VH_UPDATE_DATA', data)
          for(let attr in data){
            Bus.$emit("vh-update-data-" + attr, data[attr])
          }
        });
        socket.on('zalo-oa-web-hook', (data) => {
          if (data.contactId && data.zuid) {
            Bus.$emit("zalo-web-hook", data)
          }
        });
        socket.on('inactive_combos_of_sku', (res) => {
          if (res?.success) {
            this.$swal({
              icon: "success",
              title: 'Các sku cần chuyển ngừng hoạt động',
              confirmButtonText: 'Download',
              showCancelButton: true,
              cancelButtonText: "Đóng",
            }).then((result) => {
              if (result.value) {
                downloadFileXlsx(_.get(res, 'url', ''), _.get(res, 'fileName', ''))
              }
            })
          } else {
            this.$swal({
              icon: "error",
              title: 'Export dữ liệu thất bại',
              text: res.message,
            })
          }
        });
      }
      Bus.$on('reset-fech-notifications', () => {
        this.fetchNotifications()
      })
      Bus.$on("vh-update-data-listSaleMissCall", (busData) => {
        if(!busData){
          socket.emit('vh-update-data', 'listSaleMissCall')
        }
      })
    },

    beforeDestroy () {
      Bus.$off('reset-fech-notifications')
      Bus.$off('created-appointment-success')
    },

    methods: {
      ...mapMutations({
        setDrawer: 'SET_DRAWER',
      }),
      closeModalCall() {
        this.showModal = false
        this.mobile = ''
        this.appointmentId = 0
      },
      async updateAppointmentStatus (id, status) {
        const statusAppointment = {
          status: 'done'
        }
        const response = await AppointmentRepository.updateStatus(id, statusAppointment)
        if (!response.success) {
          this.errorMessage = _.get(response, 'message', '')
        } else {
            window.location.reload()
        }
      },
      executeCall (appointment) {
        const data = {
          mobile: appointment.mobile,
          appointmentId: appointment.id,
          dataAppointment: this.isCreate ? {} : {
            customer: _.get(appointment, 'customer', ''),
            id: _.get(appointment, 'id', ''),
          },
          showCreateAppointment: true,
        }
        Bus.$emit('voice-call-show-popup', data)
      },
      callCenter (notification) {
        const mobile = _.get(notification, 'mobile', '')
        const appointmentId = _.get(notification, 'id', 0)
        if (!mobile || !appointmentId) {
          return
        }
        this.showModal = true
        this.mobile = mobile
        this.appointmentId = appointmentId
      },
      logout () {
        TokenService.removeRefreshToken()
        TokenService.removeToken()
        TokenService.removeUser()
        TokenService.removePermissions()
        TokenService.removeModule()
        this.$router.push('/login')
      },
      goToPage (item) {
        if (!_.get(item, 'link', '')) {
          return
        }
        this.$router.push({
          name: _.get(item, 'link', ''),
        })
      },
      resetCount () {
        this.countNews = 0
      },
      newAppointment () {
        Bus.$emit('appointment-show-form-from-contact', this.appointments)
      },
      editAppointment (appointment) {
        let userPosition = TokenService.getPosition()
        let userId = TokenService.getId()
        let contact = appointment.customer.contact
        if (userPosition == 'telesales' && userId != contact.userId) {
          this.$swal({
            title: 'Lỗi !',
            text: 'Contact không thuộc quyền phụ trách.'
          })
        } else {
          const appointmentDetail = {
            id: appointment.id,
            mainId: contact.mainId,
            mainMobile: contact.phoneRelated[0],
            customer: {
              contactId: appointment.customer.contactId
            }
          }
          Bus.$emit('appointment-show-form-from-appointment', appointmentDetail)
        }
      },
      addNewNotification (notification) {
        const id = parseInt(_.get(notification, 'id', 0), 10)
        if (this.appointmentIds.indexOf(id) === -1 || this.appointmentIds.length < 1) {
          // add new
          this.appointments.splice(PAGE_LIMIT - 1)
          this.appointments.unshift(notification)
          this.appointmentIds.push(id)
          // this.countNews++
          this.totalItem++
        }
      },
      async fetchNotifications () {
        const self = this
        const response = await AppointmentRepository.listByUserLogin({
          page: 0,
          limit: 5,
          keyword: '',
          status: 'planning',
        })
        if (response.error) {
          console.log('error fetchNotifications AppointmentRepository')
        } else {
          const items = _.get(response, 'data', [])
          this.appointments = []
          this.totalItem = response.totalItem
          if (items) {
            _.forEach(items, function (item) {
              self.appointments.push(item)
              self.appointmentIds.push(parseInt(_.get(item, 'id', 0), 10))
            })
          }
        }
      },
      closeNotification(index) {
        this.hideNotifications[index].showModal = false
        let key = this.notificationPosition.indexOf(this.hideNotifications[index].id)
        this.notificationPosition.splice(key, 1)
      },
      showDrawerMobile() {
        this.$store.commit('SET_DRAWER', true)
      },
      returnHome() {
        if (this.checkAuthorization('dashboard_read')) {
          this.$router.push('/dashboard')
        } else {
          this.$router.push('contact/contact-list')
        }
      },
      stopScroll() {
        this.scrollLeft = 0
        clearInterval(this.scrollAnnouncement)
        let element = document.getElementsByClassName('announcement')
        if (element.length) {
          element[0].scrollTo({
            left: this.scrollLeft,
          })
        }
      },
      startScroll() {
        let element = document.getElementsByClassName('announcement')
        if (element.length) {
          this.scrollLeft = 0
          this.scrollAnnouncement = setInterval(() => {
            this.scrollLeft += 2
            element[0].scrollTo({
              left: this.scrollLeft,
            })
          }, 30)
        }
      },
      openLinkAnnouncement(link) {
        if (link) {
          window.open(link, '_blank')
        }
      }
    },
    updated() {
      this.$nextTick( () => {
        $('.announcement-text p').css('margin-bottom', '0px')
      })
    }
  }
</script>
<style lang="scss" scoped>
  .notification-has-0 {
    .v-badge__badge {
      display: none;
    }
  }
  .notification-has-1 {
    .v-badge__badge {
      display: inline-block;
    }
  }
  .padding-10 {
    padding: 10px;
  }
  .v-messages__message {
    color: #ff5252 !important;
    caret-color: #ff5252 !important;
  }
  .appbar-icon {
    font-size: 22px !important;
  }
  .theme--dark {
    .v-list-item__title {
      .notification {
        .notification-info {
          background-color: #e91e63;
          .notification-item {
            .v-icon {
              color: white;
            }
          }
        }
      }
    }
  }
  .notification-info {
    background-color: #f1f1f1;
    padding: 5px 10px;
    .notification-item {
      .v-icon {
        color: #a847bf;
      }
    }
  }
  .notification-header {
    padding: 5px 15px;
    color: #a847bf;
  }
  .no-outline:focus {
    outline: unset;
  }
  .hiden-person-result {
    display: none;
  }
  .announcement-container {
    display: flex;
    background-color: white;
    padding: 0px 10px;
    border-radius: 15px;
    .announcement {
      font-size: 16px;
      font-weight: 400;
      overflow: hidden;
      width: 100%;
      display: inline-flex;
      .announcement-pack {
        display: inline-flex;
        white-space: nowrap;
        .announcement-text {
          color: black;
          text-decoration: unset;
        }
        .announcement-text.has-link {
          cursor: pointer;
        }
        .announcement-text.has-link:hover {
          color: blue;
          text-decoration: underline;
          text-underline-position: below;
        }
      }
    }
  }
</style>
<style lang="css">
.v-navigation-drawer .v-icon.v-icon {
  color: #FFFFFF !important;
}
</style>
